import * as React from 'react';
import styled from 'styled-components';
import { MainGrid } from '../layout/MainGrid';
import { Brand } from './Brand';
import { Button } from './Button';
import { Card } from './card/Card';
import { Icon } from './Icon';

type IProps = React.PropsWithChildren<{}>;
interface IState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = { hasError: false };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static getDerivedStateFromError(_: any): IState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public componentDidCatch(error: any): void {
    window['TrackJS'].track(error);
    this.setState({ hasError: true });
  }

  public render(): React.ReactNode {
    if (this.state.hasError) {
      return <ErrorMessage />;
    }

    return this.props.children;
  }
}

const ErrorMessage = (): React.ReactElement => {
  const refresh = (): void => {
    window.location.reload();
  };
  return (
    <React.Fragment>
      <Header>
        <Brand />
      </Header>
      <MainGrid style={{ height: '100%' }}>
        <Card style={{ padding: '0px', height: '100%' }}>
          <Container>
            <Icon name='error' style={{ fontSize: '5em' }} />
            <MessageBody>
              <h1>Something Went Wrong</h1>
              <h5>
                Try reloading the page. If it continues to happen please reach
                out to techsupport@hawkindynamics.com or hop on the support chat
                at <a href='www.hawkindynamics.com'>www.hawkindynamics.com</a>
              </h5>
              <Button
                onClick={refresh}
                style={{ marginTop: '20px' }}
                title='Reload Page'
                icon='refresh'
              />
            </MessageBody>
          </Container>
        </Card>
      </MainGrid>
    </React.Fragment>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const MessageBody = styled.div`
  max-width: 70%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  flexdirection: row;
  align-items: center;
  height: 60px;
  padding-left: 30px;
`;
